import { computed, ref } from 'vue';

export function useLegalSearch(sections) {
  const query = ref('');

  const normalizedQuery = computed(() => query.value.trim().toLowerCase());

  const filteredSections = computed(() => {
    const q = normalizedQuery.value;
    if (!q) return sections.value;

    return sections.value
      .map((section) => {
        const matchesTitle = section.title.toLowerCase().includes(q);
        const matchesContent = (section.content ?? [])
          .join('\n')
          .toLowerCase()
          .includes(q);
        const matchesAny = matchesTitle || matchesContent;

        return matchesAny ? section : null;
      })
      .filter(Boolean);
  });

  const matchCount = computed(() => filteredSections.value.length);

  return {
    query,
    normalizedQuery,
    filteredSections,
    matchCount,
  };
}

